import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import $ from 'jquery';
import Ajax from '../ajax/Ajax';

class Box extends Component {
	
	constructor(props) {
		super(props);
		this.state = {box: {}, sorted: false};
		this.addItem = this.addItem.bind(this);
		this.updateItem = this.updateItem.bind(this);
		this.update = this.update.bind(this);
		this.sortItems = this.sortItems.bind(this);
	}
	
	componentWillMount() {
		var obj = this;
		Ajax.getBox().then(function(items) {
			var keysSorted = Object.keys(items).sort(
				function(a, b) {
					return (items[a]["name"].toLowerCase() < items[b]["name"].toLowerCase() ? -1 : 1);
				}
			);
			obj.setState({items: items, sorted: keysSorted});
		});
	}
	
	sortItems(field) {
		var obj = this;
		return function(event) {
			var list = obj.state.items;
			var keysSorted = Object.keys(list).sort(
				function(a, b) {
					return (list[a][field].toLowerCase() < list[b][field].toLowerCase() ? -1 : 1);
				}
			);
			obj.setState({sorted: keysSorted});
		}
	}
	
	update(items) {
		var obj = this;
		Ajax.postBox(items).then(function () {
			obj.setState({items: items});
		});		
	}
	
	addItem(event) {
		var obj = this;
		Ajax.getBox().then(function (items) {
			var id = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
			var item = {
					name: "",
					description: "",			
					origin: ""
				}
			items[id] = item;	
			var keysSorted = Object.keys(items).sort(
					function(a, b) {
						return (items[a]["name"].toLowerCase() < items[b]["name"].toLowerCase() ? -1 : 1);
					}
				);
			obj.setState({items: items, sorted: keysSorted});
			obj.update(items);
		});		
	}
	
	updateItem(id) {
		var obj = this;
		
		return function(event) {
			Ajax.getBox().then(function (items) {
				var el = $("#" + id);
				var name = $(".ItemName", el).first()[0].innerHTML;
				var description = $(".ItemDescription", el).first()[0].innerHTML;
				var origin = $(".ItemOrigin", el).first()[0].innerHTML;
				var item = {
					name: name,
					description: description,			
					origin: origin
				}
				
				items[id] = item;
				obj.setState({items: items});
				obj.update(items);
			});
		};
	}
	
	render() {
		var items = this.state.items;
		var sorted = this.state.sorted;
		var obj = this;
		
		return (
		<div className="Box">			
			<div className="BoxImage" />
			<div className="ItemList">
				<div className="ItemListHeaders">					
					<div className="ItemListHeader ItemName" onClick={this.sortItems("name")}>Objet</div>
					<div className="ItemListHeader ItemDescription" onClick={this.sortItems("description")}>Description</div>
					<div className="ItemListHeader ItemOrigin" onClick={this.sortItems("origin")}>Origine</div>
				</div>
				<div className="AddSymbol" onClick={this.addItem}><FontAwesomeIcon icon="box-open"/><FontAwesomeIcon icon="plus"/></div>
				
				{items && sorted ? 
				
				sorted.map(function(key, idx) {
					var item = items[key];
					return (
					<div id={key} key={idx} className="Item">
						<div className="ItemField ItemName" contentEditable="true" onBlur={obj.updateItem(key)} dangerouslySetInnerHTML={{__html: item.name}}></div>
						<div className="ItemField ItemDescription" contentEditable="true" onBlur={obj.updateItem(key)} dangerouslySetInnerHTML={{__html: item.description}}></div>
						<div className="ItemField ItemOrigin" contentEditable="true" onBlur={obj.updateItem(key)} dangerouslySetInnerHTML={{__html: item.origin}}></div>
					</div>
					)
				}): null
				}
				
			</div>        
		</div>
		);
	}
}

export default Box;



// WEBPACK FOOTER //
// ./src/components/Box.js